
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";

import globalReducer from "./globalSlice";
import userReducer from "./userSlice";
// import registerReducer from "./registerSlice";
// import farmerReducer from "./farmerSlice";
// import farmerInfoReducer from "./farmerInfoSlice";
// import subsidyReducer from "./subsidySlice";



const persistConfig = {
	key: "tms-tada-state",
	storage,
	blacklist: ["register"],
};
const reducers = combineReducers({
	global: globalReducer,
	user: persistReducer(persistConfig, userReducer),
	// register: persistReducer(persistConfig,registerReducer),
	// farmer: persistReducer(persistConfig,farmerReducer),
	// farmerInfo: persistReducer(persistConfig,farmerInfoReducer),
	// subsidy: persistReducer(persistConfig,subsidyReducer),
});
// const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
	reducer: reducers,
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});
export const persistor = persistStore(store);
